module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-2@2x-ac01bcaed4cc3832156919b40d8c2257.png";